export default __webpack_public_path__ + "static/media/brush.c2eead74.svg";